module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Ha-Ib-Ja.484373ca.png";